<template>
    <div class="inviteRanking">
        <div class="ranking-container">
            <div class="ranking-item" v-for="(item, index) in rankingList" :key="index">
                <img
                    class="index-img"
                    v-if="index === 0"
                    src="//res.peki.vip/20210428/1619591191721/1619591191723.png"
                />
                <img
                    class="index-img"
                    v-else-if="index === 1"
                    src="//res.peki.vip/20210428/1619591277897/1619591277900.png"
                />
                <img
                    class="index-img"
                    v-else-if="index === 2"
                    src="//res.peki.vip/20210428/1619591286697/1619591286703.png"
                />
                <div class="index" v-else>{{ index + 1 }}</div>
                <img class="user-avatar" :src="item.avatar" />
                <div class="nickname">{{ item.nickname }}</div>
                <div class="other">邀请{{ item.invitedCnt }}位好友</div>
            </div>
        </div>
        <div class="user-invite" v-if="userInfo">
            <div class="index">{{ currentUser && currentUser.invitedCnt !== 0 ? currentUser.invitedCnt : '-' }}</div>
            <img :src="userInfo.avatar" />
            <div class="other">
                <div>{{ userInfo.nickname }}</div>
                <div>邀请好友看直播</div>
            </div>
            <button @click="onClipUrl">邀请</button>
        </div>
        <div class="ranking-bg">
            <img class="ranking-bg1" src="https://res.peki.vip/20210428/1619590267605/1619590267605.png" />
            <img class="ranking-bg2" src="https://res.peki.vip/20210428/1619590307451/1619590307450.png" />
        </div>
        <textarea v-if="isShowLocationUrl" ref="locationUrl" :value="locationUrl"></textarea>
    </div>
</template>
<script>
import { getUserInfo } from '@/utils/login.js'
import { urlQuery } from '@/utils/utils.js'
import { getShareRank, userShareAction } from '@/utils/api.js'

export default {
    props: ['liveCourse'],
    data() {
        return {
            userInfo: null,
            isShowLocationUrl: false,
            locationUrl: '',
            rankingList: [],
            currentUser: null,
        }
    },
    created() {
        this.userInfo = getUserInfo()
    },
    methods: {
        onClipUrl() {
            if (navigator && navigator.clipboard) {
                const options = urlQuery()
                const _host = `${window.location.origin}${window.location.pathname}`
                const _url = `${_host}?courseToken=${options.courseToken}&inviter=${this.userInfo.id}&sn=invite`
                navigator.clipboard.writeText(_url).then(() => {
                    this.$toast('复制成功，赶紧发给好友吧～')
                })
            } else {
                this.$toast('复制失败，请手动复制地址栏发送给好友～')
            }
            userShareAction({ courseId: this.liveCourse.id, userId: this.userInfo.id })
        },
        getShareRankApi() {
            getShareRank({
                courseId: this.liveCourse.id,
                userId: this.userInfo.id,
            }).then((res) => {
                if (res.data) {
                    this.rankingList = res.data.ranks || []
                    this.currentUser = res.data.current || null
                }
            })
        },
    },
}
</script>
<style lang="scss" scoped>
.inviteRanking {
    padding-bottom: 60px;
    box-sizing: border-box;
    position: absolute;
    width: 100%;
    height: 100%;
    bottom: 0;
    overflow: hidden;
}
.user-invite {
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 12;
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 8px;
    box-sizing: border-box;
    font-size: 13px;
    background: #fff;
    .index {
        color: #666;
        flex-shrink: 0;
        margin: 0 8px 0 12px;
        text-align: center;
    }
    img {
        width: 36px;
        height: 36px;
        border-radius: 50%;
    }
    .other {
        line-height: 1.4em;
    }
    button {
        border: none;
        background: linear-gradient(90deg, #3ed6b6, #44cd94);
        color: #fff;
        width: 60px;
        height: 28px;
        border-radius: 2px;
        cursor: pointer;
        &:active {
            opacity: 0.8;
        }
    }
}
.ranking-container {
    width: 92%;
    overflow-y: scroll;
    padding-top: 6px;
    background: #fff;
    border-radius: 10px;
    position: absolute;
    left: 4%;
    top: 100px;
    bottom: 100px;
    z-index: 11;
    box-sizing: border-box;
}
.ranking-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 12px;
    font-size: 12px;
    .index {
        color: #666;
        flex-shrink: 0;
        width: 14px;
        height: 14px;
        margin: 0 6px;
        background: #fff5f1;
        border-radius: 50%;
        border: 1px solid #f28d28;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 700;
        color: #ff715c;
    }
    .index-img {
        width: 27px;
        height: 27px;
    }
    .other {
        flex-grow: 1;
        text-align: right;
        min-width: 80px;
        color: #444;
    }
    .nickname {
        font-weight: 700;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .user-avatar {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        margin: 0 6px 0 6px;
    }
}
textarea {
    width: 0;
    height: 0;
    opacity: 0;
}
.ranking-bg {
    position: absolute;
    top: -36px;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    img {
        width: 100%;
        display: block;
    }
    .ranking-bg2 {
        flex-grow: 1;
    }
}
</style>
